<template>
  <modal 
    name="confirm-modal" 
    :pivotY="0.2"
    :height="'auto'"
    :width="width"
    @opened="opened"
    @before-open="beforeOpen">

    <!-- we are loading the pages right now -->
    <div class="border-b p-4 flex justify-between items-center">
      <div class="text-base text-gray-800">
        {{ title }}
      </div>

      <a href="#"
        v-on:click.prevent="$modal.hide('confirm-modal')"
        class="text-grey hover:text-grey-darker">
        <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
          <use xlink:href="/img/feather-sprite.svg#x"/>
        </svg>
      </a>
    </div>
    
    <div class="p-4">

      <div class="text-sm" v-html="message" />

      <div class="mt-3"></div>

      <div class="mt-6 flex items-center">
        <template v-for="(button, index) in buttons">
          <SubmitButton2 
            v-bind:label="button.label" 
            v-bind:onClick="button.action" 
            v-bind:color="button.color"
            v-bind:loading="loading"
            v-bind:loadingViaLocal="button.loadingViaLocal" />
        </template>
      </div>
    </div>
  </modal>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus'
  import SubmitButton2  from '@/shared/components/form/SubmitButton2'

  export default {

    components : {
      SubmitButton2
    },

    data() {
      return {
        width  : 450,
        title  : 'Please confirm',
        message: null,
        buttons: null,
        loading: false
      }
    },

    methods : {

      beforeOpen(event) {
        // this.width = event.params != null && event.params.width != null ? event.params.width : null
        this.loading = event.params != null && event.params.loading != null ? event.params.loading : null
        this.title   = event.params != null && event.params.title != null ? event.params.title : null
        this.message = event.params != null && event.params.message != null ? event.params.message : null
        this.buttons = event.params != null && event.params.buttons != null ? event.params.buttons : null
      },

      opened(event) {
        
      },     
    }
  }
</script>